import { Form, useFormState } from '@carboledger/ui';
import { MB_PERIOD_STATUS } from '@/config/statuses';
import { TextField } from '@/components/common';
import { useTranslations } from '@/hooks';
import { MB_PERIOD_DETAIL_FIELDS, mbPeriodFieldName } from '../../constants/sites.constants';
import styles from './MbPeriodCard.module.scss';

const DATE_LOCKED_STATUSES = [MB_PERIOD_STATUS.open, MB_PERIOD_STATUS.closed];

/**
 * Props:
 *   periodKey  the period number this card edits
 */
export const MbPeriodCard = ({ periodKey }) => {
  const t = useTranslations();
  const { values } = useFormState();

  const status = values[mbPeriodFieldName(periodKey, MB_PERIOD_DETAIL_FIELDS.status)];
  const datesLocked = DATE_LOCKED_STATUSES.includes(status);

  return (
    <div className={styles.card}>
      <TextField
        required
        name={mbPeriodFieldName(periodKey, MB_PERIOD_DETAIL_FIELDS.name)}
        label={t('FIELD_PERIOD_NAME')}
        placeholder={t('FORM_ENTER_PERIOD_NAME')}
      />

      <Form.Row columns={2}>
        <TextField
          required
          type="date"
          disabled={datesLocked}
          name={mbPeriodFieldName(periodKey, MB_PERIOD_DETAIL_FIELDS.startDate)}
          label={t('FIELD_PERIOD_START_DATE')}
        />
        <TextField
          required
          type="date"
          disabled={datesLocked}
          name={mbPeriodFieldName(periodKey, MB_PERIOD_DETAIL_FIELDS.endDate)}
          label={t('FIELD_PERIOD_END_DATE')}
        />
      </Form.Row>
    </div>
  );
};
